export default "__VITE_ASSET__382628fd__"